<nz-header class="section-header">
  {{ "General" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.medicalResearchCouncilScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="18"
      [historyItems]="getTemplateItems(18)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.barthelIndex) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="29"
      [historyItems]="getTemplateItems(29)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.functionalIndependenceMeasure) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="30"
      [historyItems]="getTemplateItems(30)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.motricityIndex) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="31"
      [historyItems]="getTemplateItems(31)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
